import { parseHTML } from "~/foundation/Dom/elementManipulation";
import { crossIcon, headPhonesIcon, pauseIcon, playIcon } from "../icons/icons";

export const audioBar = ({
	duration,
	currentTime,
	audioFileUrl,
	isPlaying,
	title
}) => {
	const playerIcon = isPlaying ? pauseIcon : playIcon;
	const progressWidth = duration > 0 ? (currentTime / duration) * 100 : 0;
	const remainingTime = duration > 0 ? duration - currentTime : 0;

	return parseHTML(`
        <div class="article-audioplayer__bar-container">
						<div class="article-audioplayer__info">
							<button class="article-audioplayer__toggle" aria-label="Close audio">
								<div class="active">
									${headPhonesIcon}
								</div>
								<div class="passive">
									${crossIcon}
								</div>
							</button>
							<h4 class="audio-title">${title || "Audio"}</h4>
						</div>

            <audio controls class="article-audioplayer__audio visuallyhidden">
                <source src=${audioFileUrl} type="audio/mpeg">
                Your browser does not support the audio tag.
            </audio>

            <div class="article-audioplayer__time-container">
                <span class="article-audioplayer__time-current">${currentTime}</span>
                <div class="article-audioplayer__progressbar-container">
                    <span class="article-audioplayer__progressbar" style="width: ${progressWidth}%"></span>
                    <button
                        class="article-audioplayer__play-pause"
                        aria-label=${isPlaying ? "Pause audio" : "Play audio"}
                    >
                        ${playerIcon}
                    </button>
                </div>
                <span class="article-audioplayer__time-remaining">-${remainingTime}</span>
            </div>
        </div>
    `);
};
